var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.contextAdvances, function(item, index) {
      return _c(
        "div",
        { key: item.id },
        [
          _c(
            "v-row",
            { staticClass: "flex-nowrap", attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "3" } },
                [
                  _c("amount-input", {
                    attrs: {
                      readonly: _vm.readonly,
                      "error-messages": _vm.amountInCurrencyValidation(
                        item,
                        index
                      ),
                      model: item.amount_in_currency
                    },
                    on: {
                      "update:model": function($event) {
                        return _vm.$set(item, "amount_in_currency", $event)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "3" } },
                [
                  _c("currency-select", {
                    attrs: {
                      readonly: _vm.readonly,
                      model: item.currency,
                      "validation-message": _vm.currencyValidation(item, index)
                    },
                    on: {
                      "update:model": function($event) {
                        return _vm.$set(item, "currency", $event)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "3" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "error-messages": _vm.paymentTypeValidation(item, index),
                      items: _vm.payment_types,
                      clearable: !_vm.readonly,
                      "item-text": "name",
                      "item-value": "id",
                      label: _vm.$t(
                        "components.advance.fields.paymentType.name"
                      ),
                      readonly: _vm.readonly
                    },
                    model: {
                      value: item.payment_type,
                      callback: function($$v) {
                        _vm.$set(item, "payment_type", $$v)
                      },
                      expression: "item.payment_type"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "3" } },
                [
                  _c("date-picker", {
                    attrs: {
                      "date-validation": _vm.paymentDateValidation(item, index),
                      model: item.payment_date,
                      label: _vm.$t(
                        "components.advance.fields.paymentDate.name"
                      ),
                      max: _vm.maxDate,
                      readonly: _vm.readonly
                    },
                    on: {
                      "update:model": function($event) {
                        return _vm.$set(item, "payment_date", $event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm.clearable & !_vm.readonly
                ? _c(
                    "v-icon",
                    {
                      on: {
                        click: function($event) {
                          return _vm.removeAdvance(item)
                        }
                      }
                    },
                    [_vm._v("close")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm.isExtendedAdvancesEnabled
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "8" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("global.comment"),
                          readonly: _vm.readonly
                        },
                        model: {
                          value: item.comment,
                          callback: function($$v) {
                            _vm.$set(item, "comment", $$v)
                          },
                          expression: "item.comment"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("ajax-file", {
                        attrs: { items: item.files, readonly: _vm.readonly }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          index < _vm.contextAdvances.length - 1
            ? _c("v-divider", { staticClass: "mb-4" })
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }